import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';
import { UtilService } from 'src/app/service/util.service';

interface Cliente {
  id: number;
  nome: string;
  cnpj: string;
  dataCadastro: Date;
  empresaGestora: boolean;
}

interface CronogramaBase {
  id: number;
  nome: string;
  dataCriacao: Date;
}

interface CronogramaCliente {
  id: number;
  idCliente: number;
  idCronogramaBase: number;
  nome: string;
  dataCadastro: Date;
  dataInicio: Date;
  dataFim: Date;
  status: string;
}

interface CronogramaItemBase {
  id: number;
  idCronogramaBase: number;
  nome: string;
  descricao: string;
  ordem: number;
  prazoEmDias: number;
  dataInicio?: Date | null;
  dataFim?: Date | null;
}

@Component({
  selector: 'app-cronograma-cliente',
  templateUrl: './cronograma-cliente.component.html',
  styleUrls: ['./cronograma-cliente.component.scss']
})
export class CronogramaClienteComponent implements OnInit {
  clientes: Cliente[] = [];
  cronogramasBase: CronogramaBase[] = [];
  cronogramasCliente: CronogramaCliente[] = [];
  clienteSelecionado: Cliente | null = null;
  itensCronogramaBase: CronogramaItemBase[] = [];
  cronogramaBaseSelecionado: CronogramaBase | null = null;
  
  vincularForm: FormGroup;
  dtOptions: DataTables.Settings = {};
  termoBusca: string = '';

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    public modalService: NgbModal,
    private ajax: AjaxService,
    private util: UtilService
  ) {
    this.vincularForm = this.fb.group({
      idCronogramaBase: ['', [Validators.required]],
      dataInicio: ['', [Validators.required]],
      dataFim: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.13.7/i18n/pt-BR.json'
      }
    };
    this.buscarClientes();
    this.carregarCronogramasBase();
  }

  buscarClientes() {
    this.util.showLoading();
    let url = `${API}Empresa/Empresa`;
    
    // Adiciona o termo de busca se existir
    if (this.termoBusca && this.termoBusca.trim() !== '') {
      url += `?nome=${encodeURIComponent(this.termoBusca.trim())}`;
    }

    this.ajax.get(url)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.clientes = response.data.map((cliente: any) => ({
              id: cliente.id,
              nome: cliente.nomE_FANTASIA,
              cnpj: cliente.cnpj,
              dataCadastro: new Date(cliente.datA_CADASTRO),
              empresaGestora: cliente.iS_EMPRESA_GESTORA
            }));
          } else {
            this.clientes = [];
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao buscar clientes. Tente novamente.");
          console.error('Erro ao buscar clientes:', error);
        }
      });
  }

  carregarClientes() {
    // Implementar chamada à API
    this.clientes = [
      {
        id: 1,
        nome: 'Hospital São Lucas',
        cnpj: '00.000.000/0001-00',
        dataCadastro: new Date('2024-01-15'),
        empresaGestora: true
      },
      {
        id: 2,
        nome: 'Clínica Saúde Total',
        cnpj: '00.000.000/0002-00',
        dataCadastro: new Date('2024-02-01'),
        empresaGestora: false
      },
      {
        id: 3,
        nome: 'Laboratório Diagnóstico',
        cnpj: '00.000.000/0003-00',
        dataCadastro: new Date('2024-02-15'),
        empresaGestora: false
      },
      {
        id: 4,
        nome: 'Centro Médico Esperança',
        cnpj: '00.000.000/0004-00',
        dataCadastro: new Date('2024-03-01'),
        empresaGestora: true
      }
    ];
  }

  carregarCronogramasBase() {
    this.util.showLoading();
    this.ajax.get(`${API}CronogramaBase/CronogramaBase`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.cronogramasBase = response.data.map((cronograma: any) => ({
              id: cronograma.id,
              nome: cronograma.nome,
              dataCriacao: new Date(cronograma.datA_CRIACAO)
            }));
          } else {
            this.cronogramasBase = [];
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar cronogramas base. Tente novamente.");
          console.error('Erro ao carregar cronogramas base:', error);
        }
      });
  }

  carregarCronogramasCliente(clienteId: number) {
    this.util.showLoading();
    this.ajax.get(`${API}CronogramaEmpresa/CronogramaEmpresa?ID_EMPRESA=${clienteId}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.cronogramasCliente = response.data.map((cronograma: any) => ({
              id: cronograma.id,
              idCliente: cronograma.id_EMPRESA,
              idCronogramaBase: cronograma.id_CRONOGRAMA_BASE,
              dataCadastro: new Date(cronograma.datA_CADASTRO),
              inicio: new Date(cronograma.inicio),
              fim: new Date(cronograma.fim),
              status: cronograma.status,
              nome: cronograma.nome
            }));
          } else {
            this.cronogramasCliente = [];
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar cronogramas do cliente. Tente novamente.");
          console.error('Erro ao carregar cronogramas do cliente:', error);
        }
      });
  }

  selecionarCliente(cliente: Cliente) {
    this.clienteSelecionado = cliente;
    this.carregarCronogramasCliente(cliente.id);
  }

  abrirModalVincular(modal: any) {
    if (this.clienteSelecionado) {
      this.vincularForm.reset({
        dataInicio: new Date(),
        dataFim: new Date(new Date().setMonth(new Date().getMonth() + 1))
      });
      this.modalService.open(modal, {
        backdrop: 'static',
        keyboard: false
      });
    }
  }

  vincularCronograma() {
    if (this.vincularForm.valid && this.clienteSelecionado) {
      this.util.showLoading();
      const novoCronograma = {
        ID_EMPRESA: this.clienteSelecionado.id,
        ID_CRONOGRAMA_BASE: parseInt(this.vincularForm.value.idCronogramaBase),
        INICIO: this.vincularForm.value.dataInicio,
        FIM: this.vincularForm.value.dataFim,
        STATUS: 'Ativo'
      };

      this.ajax.post(`${API}CronogramaEmpresa/CronogramaEmpresa/CopiarCronogramaBase`, novoCronograma)
        .subscribe({
          next: (response) => {
            this.util.closeLoading();
            if (response && response.data) {
              this.util.toasterShowSuccess("Sucesso", "Cronograma vinculado com sucesso!");
              this.modalService.dismissAll();
              this.carregarCronogramasCliente(this.clienteSelecionado.id);
            } else {
              this.util.toasterShowError("Erro", "Erro ao vincular cronograma. Tente novamente.");
            }
          },
          error: (error) => {
            this.util.closeLoading();
            this.util.toasterShowError("Erro", error.error.message || "Erro ao vincular cronograma. Tente novamente.");
            console.error('Erro ao vincular cronograma:', error);
          }
        });
    } else {
      this.util.toasterShowError("Atenção", "Por favor, preencha todos os campos obrigatórios.");
    }
  }

  alterarStatus(cronograma: CronogramaCliente) {
    const novoStatus = cronograma.status === 'Ativo' ? 'Inativo' : 'Ativo';
    
    // Implementar chamada à API
    console.log('Alterar status do cronograma:', {
      id: cronograma.id,
      status: novoStatus
    });

    cronograma.status = novoStatus;
  }


  getCronogramaBaseById(idCronogramaBase: number): CronogramaBase | undefined {
    return this.cronogramasBase.find(c => c.id === idCronogramaBase);
  }

  abrirModalItensCronogramaBase(modal: any, cronograma: CronogramaCliente) {
    if (cronograma) {
      this.cronogramaBaseSelecionado = {
        id: cronograma.idCronogramaBase,
        nome: cronograma.nome,
        dataCriacao: cronograma.dataCadastro
      };
      this.carregarItensCronogramaBase(cronograma.id);
      this.modalService.open(modal, {
        backdrop: 'static',
        keyboard: false,
        size: 'lg'
      });
    } else {
      this.util.toasterShowError("Erro", "Cronograma não encontrado.");
    }
  }

  carregarItensCronogramaBase(idCronogramaBase: number) {
    this.util.showLoading();
    if(idCronogramaBase == null || idCronogramaBase == undefined){
      this.itensCronogramaBase = [];
      return;
    }

    this.ajax.get(`${API}CronogramaEmpresa/CronogramaEmpresa/buscarItensByCronograma?ID_CRONOGRAMA_EMPRESA=${idCronogramaBase}`)
      .subscribe({
        next: (response) => {
          this.util.closeLoading();
          if (response && response.data) {
            this.itensCronogramaBase = response.data.map((item: any) => ({
              id: item.id,
              idCronogramaBase: item.id_CRONOGRAMA_BASE,
              nome: item.nome,
              descricao: item.descricao,
              ordem: item.ordem,
              prazoEmDias: item.prazO_EM_DIAS,
              dataInicio: item.inicio ? new Date(item.inicio) : null,
              dataFim: item.fim ? new Date(item.fim) : null
            }));
          } else {
            this.itensCronogramaBase = [];
          }
        },
        error: (error) => {
          this.util.closeLoading();
          this.util.toasterShowError("Erro", "Erro ao carregar itens do cronograma. Tente novamente.");
          console.error('Erro ao carregar itens do cronograma:', error);
        }
      });
  }

  alterarDataInicioItem(item: CronogramaItemBase, novaData: Date) {
    item.dataInicio = novaData;
    // Recalcular data fim baseado no prazo em dias
    if (item.prazoEmDias) {
      item.dataFim = new Date(new Date(novaData).setDate(novaData.getDate() + item.prazoEmDias));
    }
    // Implementar chamada à API para salvar as alterações
    console.log('Alterar data início do item:', {
      id: item.id,
      dataInicio: item.dataInicio,
      dataFim: item.dataFim
    });
  }

  alterarDataFimItem(item: CronogramaItemBase, novaData: Date) {
    item.dataFim = novaData;
    // Recalcular prazo em dias baseado nas datas
    if (item.dataInicio) {
      const diffTime = Math.abs(novaData.getTime() - item.dataInicio.getTime());
      item.prazoEmDias = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    // Implementar chamada à API para salvar as alterações
    console.log('Alterar data fim do item:', {
      id: item.id,
      dataInicio: item.dataInicio,
      dataFim: item.dataFim,
      prazoEmDias: item.prazoEmDias
    });
  }

  salvarAlteracoesItens() {
    if (this.itensCronogramaBase.length > 0) {
      this.util.showLoading();
      
      // Mapeia os itens para o formato esperado pela API
      const itensParaSalvar = this.itensCronogramaBase.map(item => ({
        ID_CRONOGRAMA_EMPRESA_ITEM: item.id,
        INICIO: item.dataInicio,
        FIM: item.dataFim
      }));

      debugger
      // Faz a chamada para a API
      this.ajax.post(`${API}CronogramaEmpresaItem/CronogramaEmpresaItem/AlterarPeriodosCronogramaEmpresa`, itensParaSalvar)
        .subscribe({
          next: (response) => {
            this.util.closeLoading();
            if (response && response.data) {
              this.util.toasterShowSuccess("Sucesso", "Alterações salvas com sucesso!");
              this.modalService.dismissAll();
              // Recarrega os itens do cronograma
              if (this.cronogramaBaseSelecionado) {
                this.carregarItensCronogramaBase(this.cronogramaBaseSelecionado.id);
              }
            } else {
              this.util.toasterShowError("Erro", "Erro ao salvar alterações. Tente novamente.");
            }
          },
          error: (error) => {
            this.util.closeLoading();
            this.util.toasterShowError("Erro", error.error.message || "Erro ao salvar alterações. Tente novamente.");
            console.error('Erro ao salvar alterações:', error);
          }
        });
    } else {
      this.util.toasterShowError("Atenção", "Não há itens para salvar.");
    }
  }
} 